export default __webpack_public_path__ + "47f5436bc8172604db1bb3ae31d6c1dc.png";